// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2wHjQ{margin:0 auto;max-width:1112px;max-width:69.5rem;padding:1.5rem 1.625rem 4rem}@media(min-width:768px)and (max-width:1023px){._2wHjQ{padding-left:6.75rem;padding-right:6.75rem}}@media(min-width:1024px)and (max-width:1439px){._2wHjQ{padding-left:5.875rem;padding-right:5.875rem}}@media(min-width:1440px){._2wHjQ{padding-left:0;padding-right:0}}.vYcfl{margin-bottom:1.5rem;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;cursor:pointer}.vYcfl path[fill]{fill:#231815}.vYcfl h5{margin-left:.75rem}@media(min-width:768px){.vYcfl{margin-bottom:2rem}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_2wHjQ",
	"backIconWrapper": "vYcfl"
};
module.exports = exports;
